"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
const consts_1 = require("./consts");
const scheduler_1 = require("./scheduler");
/* SUBSCRIBER */
class Subscriber {
    constructor() {
        /* VARIABLES */
        this.args = undefined;
        this.listeners = [];
        this._trigger = this.trigger.bind(this);
    }
    /* API */
    subscribe(listener) {
        if (this.listeners.indexOf(listener) >= 0)
            return consts_1.NOOP;
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }
    schedule(...args) {
        return scheduler_1.default.schedule(this._trigger);
    }
    trigger(...args) {
        const { listeners } = this, { length } = listeners;
        for (let i = 0; i < length; i++) {
            listeners[i].apply(undefined, args);
        }
    }
}
/* EXPORT */
exports.default = Subscriber;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3Vic2NyaWJlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uL3NyYy9zdWJzY3JpYmVyLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFDQSxZQUFZOztBQUVaLHFDQUE4QjtBQUM5QiwyQ0FBb0M7QUFHcEMsZ0JBQWdCO0FBRWhCLE1BQU0sVUFBVTtJQUFoQjtRQUVFLGVBQWU7UUFFTCxTQUFJLEdBQTZCLFNBQVMsQ0FBQztRQUMzQyxjQUFTLEdBQTZCLEVBQUUsQ0FBQztRQUN6QyxhQUFRLEdBQUcsSUFBSSxDQUFDLE9BQU8sQ0FBQyxJQUFJLENBQUcsSUFBSSxDQUFFLENBQUM7SUFxQ2xELENBQUM7SUFuQ0MsU0FBUztJQUVULFNBQVMsQ0FBRyxRQUFnQztRQUUxQyxJQUFLLElBQUksQ0FBQyxTQUFTLENBQUMsT0FBTyxDQUFHLFFBQVEsQ0FBRSxJQUFJLENBQUM7WUFBRyxPQUFPLGFBQUksQ0FBQztRQUU1RCxJQUFJLENBQUMsU0FBUyxDQUFDLElBQUksQ0FBRyxRQUFRLENBQUUsQ0FBQztRQUVqQyxPQUFPLEdBQUcsRUFBRTtZQUVWLElBQUksQ0FBQyxTQUFTLEdBQUcsSUFBSSxDQUFDLFNBQVMsQ0FBQyxNQUFNLENBQUcsQ0FBQyxDQUFDLEVBQUUsQ0FBQyxDQUFDLEtBQUssUUFBUSxDQUFFLENBQUM7UUFFakUsQ0FBQyxDQUFDO0lBRUosQ0FBQztJQUVELFFBQVEsQ0FBRyxHQUFHLElBQVc7UUFFdkIsT0FBTyxtQkFBUyxDQUFDLFFBQVEsQ0FBRyxJQUFJLENBQUMsUUFBUSxDQUFFLENBQUM7SUFFOUMsQ0FBQztJQUVELE9BQU8sQ0FBRyxHQUFHLElBQWtCO1FBRTdCLE1BQU0sRUFBQyxTQUFTLEVBQUMsR0FBRyxJQUFJLEVBQ2xCLEVBQUMsTUFBTSxFQUFDLEdBQUcsU0FBUyxDQUFDO1FBRTNCLEtBQU0sSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxNQUFNLEVBQUUsQ0FBQyxFQUFFLEVBQUc7WUFFakMsU0FBUyxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBRyxTQUFTLEVBQUUsSUFBSSxDQUFFLENBQUM7U0FFeEM7SUFFSCxDQUFDO0NBRUY7QUFFRCxZQUFZO0FBRVosa0JBQWUsVUFBVSxDQUFDIn0=